import { useState, useEffect } from "react";
import _ from "lodash";
import moment from "moment";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";

import DateQuestion from "components/login/Questions/DateQuestion";
import birthday from "assets/images/registerImg/birth.png";
import ProfileFields from "consts/profileFields";
import { updateProfile } from "redux/profile/actions";
import { getUserProfile } from "redux/profile/selectors";
import Stance from "consts/stance";
import LoginSteps from "consts/loginSteps";
import { updateDefaultMessagesFilter } from "redux/chatReceivedFiltered/actions";

export default ({ profile, stepName, steps, goToNamedStep, onFinalStepFinish }) => {
	const index = steps.indexOf(stepName);
	const total = steps.length;
	const dispatch = useDispatch();
	const [isClickedNext, setIsClickedNext] = useState(false);
	const loggedInUserProfile = useSelector(getUserProfile);

	const handleOnSubmit = (value) => {
		dispatch(updateProfile(ProfileFields.Dob, moment(value).unix()));
		setIsClickedNext(true);
	};

	const handleOnBackButtonClick = () => {
		if (
			profile[ProfileFields.Stance] !== Stance.Mesorati &&
			steps[index - 1] === LoginSteps.KosherFood
		) {
			goToNamedStep(steps[index - 3]);
		} else {
			goToNamedStep(steps[index - 1]);
		}
	};

	useEffect(() => {
		if (isClickedNext && !_.isNil(profile[ProfileFields.Dob])) {
			if (!_.isNil(profile[ProfileFields.Gender])) {
				dispatch(updateDefaultMessagesFilter());
			}
			if (total - 1 <= index) {
				onFinalStepFinish();
			} else {
				goToNamedStep(steps[index + 1]);
			}
		}
	}, [isClickedNext, profile]);

	return (
		<div className="loginHolder">
			<div className="imageForPage">
				<img src={birthday} />
			</div>
			<DateQuestion
				title={i18next.t("Login.What is your birthday")}
				subTitle={i18next.t("Login.Min age")}
				onSubmit={handleOnSubmit}
				showBackButton={index > 0}
				onBackButtonClick={handleOnBackButtonClick}
				translationPrefix="Dob"
				initValue={
					loggedInUserProfile.dob && moment.unix(loggedInUserProfile.dob).format("YYYY-MM-DD")
				}
			/>
		</div>
	);
};
